export default __webpack_public_path__ + "static/media/segre26.d356b1ac.jpg";